import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ma-4" }

import { onMounted, ref } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import SingleChart from "@/components/SmartLink/charts/SingleChart.vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import { getCambiumDataByIp } from "@/services/Smartlink/Graphs";


export default /*@__PURE__*/_defineComponent({
  __name: 'pmp-sm',
  props: {
  title: { required: true },
  ip: { required: true, type: String },
},
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props;

const allArrayCambiumData = ref({
  radioh: [],
  radiov: [],
  throug: [],
  snrhor: [],
  snrver: [],
});

/**
 * Si trae valores la API, muestra su grafico.
 */
const showGraphs = ref(true);

/**
 * get All Data from API to Graph (linkradiohoriz, linkradiovert, throughput, snr)
 */
async function getDataGraph(type: string) {
  const params = {
    ip: props.ip,
    type: type,
  };
  const allData = await getCambiumDataByIp(params);

  if (allData.status === 400) {
    showGraphs.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showGraphs.value = allData.showGraphs;
    allArrayCambiumData.value.radioh = allData.data.radioh;
    allArrayCambiumData.value.radiov = allData.data.radiov;
    allArrayCambiumData.value.throug = allData.data.throug;
    allArrayCambiumData.value.snrhor = allData.data.snrhor;
    allArrayCambiumData.value.snrver = allData.data.snrver;
  }
}

onMounted(async () => {
  getDataGraph("cambium_data");
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showGraphs.value)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "6",
              xl: "6",
              class: "pa-0 pr-sm-2 pr-md-2 pr-lg-2 pr-xl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, {
                  class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                  color: "bgtopology"
                }, {
                  default: _withCtx(() => [
                    (allArrayCambiumData.value.snrver.length !== 0)
                      ? (_openBlock(), _createBlock(SingleChart, {
                          key: 0,
                          name: 'SNRVertical',
                          "first-array": allArrayCambiumData.value.snrver,
                          title: "SNRVertical",
                          color: _unref(COLOR).single
                        }, null, 8, ["first-array", "color"]))
                      : (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 1,
                          class: "text-center",
                          color: "transparent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Prog_circular)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "6",
              xl: "6",
              class: "pa-0 pl-sm-2 pl-md-2 pl-lg-2 pl-xl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, {
                  class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                  color: "bgtopology"
                }, {
                  default: _withCtx(() => [
                    (allArrayCambiumData.value.snrhor.length !== 0)
                      ? (_openBlock(), _createBlock(SingleChart, {
                          key: 0,
                          name: 'SNRHorizontal',
                          "first-array": allArrayCambiumData.value.snrhor,
                          title: "SNRHorizontal",
                          color: _unref(COLOR).single
                        }, null, 8, ["first-array", "color"]))
                      : (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 1,
                          class: "text-center",
                          color: "transparent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Prog_circular)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showGraphs.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 1,
          class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            (allArrayCambiumData.value.radioh.length !== 0)
              ? (_openBlock(), _createBlock(SingleChart, {
                  key: 0,
                  name: 'RXHorizontal',
                  "first-array": allArrayCambiumData.value.radioh,
                  title: "RXHorizontal",
                  color: _unref(COLOR).single
                }, null, 8, ["first-array", "color"]))
              : (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 1,
                  class: "text-center",
                  color: "transparent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Prog_circular)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (showGraphs.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 2,
          class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            (allArrayCambiumData.value.radiov.length !== 0)
              ? (_openBlock(), _createBlock(SingleChart, {
                  key: 0,
                  name: 'RXVertical',
                  "first-array": allArrayCambiumData.value.radiov,
                  title: "RXVertical",
                  color: _unref(COLOR).single
                }, null, 8, ["first-array", "color"]))
              : (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 1,
                  class: "text-center",
                  color: "transparent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Prog_circular)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (showGraphs.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 3,
          class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            (allArrayCambiumData.value.throug.length !== 0)
              ? (_openBlock(), _createBlock(SingleChart, {
                  key: 0,
                  name: 'throughput',
                  "first-array": allArrayCambiumData.value.throug,
                  title: "throughput",
                  color: _unref(COLOR).single
                }, null, 8, ["first-array", "color"]))
              : (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 1,
                  class: "text-center",
                  color: "transparent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Prog_circular)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})